__turbopack_context__.v({
  "attendeeDetails": "urVn7a_attendeeDetails",
  "attendeeItem": "urVn7a_attendeeItem",
  "attendeeList": "urVn7a_attendeeList",
  "attendeeName": "urVn7a_attendeeName",
  "dropdownIcon": "urVn7a_dropdownIcon",
  "header": "urVn7a_header",
  "itemsCount": "urVn7a_itemsCount",
  "searchBox": "urVn7a_searchBox",
  "title": "urVn7a_title",
});
